import { render, staticRenderFns } from "./NewReferralCodes.vue?vue&type=template&id=2d5966f4"
import script from "./NewReferralCodes.vue?vue&type=script&setup=true&lang=js"
export * from "./NewReferralCodes.vue?vue&type=script&setup=true&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports